import { Typography, useTheme } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';
import { COLORS } from '@tbd/life-tokens';

const Tag: FC<PropsWithChildren<TypographyProps>> = (props) => {
  const theme = useTheme();
  return (
    <Typography
      noWrap
      variant="component-bold-xs"
      sx={{
        padding: theme.spacing(1),
        backgroundColor: COLORS.neutral_100,
        color: COLORS.neutral_600,
        borderRadius: '2px',
        ...props.sx,
      }}
    >
      {props.children}
    </Typography>
  );
};

export default Tag;
